import { Text, VFlow } from 'bold-ui'
import { ReceitaMedicamento } from 'graphql/types.generated'
import React from 'react'
import { formatDate } from 'util/date/formatDate'

interface MedicamentosTratamentoInterrompidoSectionProps {
  receita: ReceitaMedicamento
}

function MedicamentosTratamentoInterrompidoSectionInternal(
  props: Readonly<MedicamentosTratamentoInterrompidoSectionProps>
) {
  const { receita } = props

  return (
    <VFlow vSpacing={0}>
      <Text fontWeight='bold'>Tratamento interrompido</Text>
      {receita.dtInterrupcao && (
        <Text data-cy='MedicamentoAtivosConcluidos.dtInterrupcao'>{formatDate(receita.dtInterrupcao)}</Text>
      )}
      {receita.justificativaInterrupcao && (
        <Text data-cy='MedicamentoAtivosConcluidos.JustificativaInterrompido'>{receita.justificativaInterrupcao}</Text>
      )}
    </VFlow>
  )
}

export const MedicamentosTratamentoInterrompidoSection = React.memo(MedicamentosTratamentoInterrompidoSectionInternal)
